import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {usePageURLContext} from "../../../contexts/pageURLContext";
import {requestGroup} from "../../../redux/Actions/group.action";
import {
  getGroupsList,
  getGroupsPaginationUrls,
  getTotalCount,
} from "../../../redux/Selectors/group.selector";
import {generateQueryUrl} from "../../../helpers/generateQueryUrl";
import {groupListURL} from "./groupsTable.constants";

export const useFetchGroups = () => {
  const {pageUrl} = usePageURLContext();
  const dispatch = useDispatch();

  const freshFetch = () => {
    dispatch(requestGroup());
  };

  const refetch = () => {
    dispatch(requestGroup(pageUrl));
  };

  return {refetch, freshFetch};
};

export const useGroupsTableData = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const {refetch, freshFetch} = useFetchGroups();
  const {setPageUrl} = usePageURLContext();
  const groups = useSelector(getGroupsList);
  const groupUrls = useSelector(getGroupsPaginationUrls);
  const totalCount = useSelector(getTotalCount);

  useEffect(() => {
    freshFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAfterDelete = () => {
    if (groups.length === 1) {
      // If the last group on the current page is deleted, reset to the first page
      setCurrentPage(1);
      setPageUrl("");
      freshFetch();
    } else {
      refetch();
    }
  };

  const handlePagination = (page) => {
    const url = currentPage < page ? groupUrls?.nextUrl : groupUrls?.prevUrl;
    dispatch(requestGroup(url));
    setCurrentPage(page);
    setPageUrl(url);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePagination,
  };

  const handleSearch = (tokens) => {
    if (tokens?.length > 0) {
      const searchUrl = generateQueryUrl(groupListURL, tokens);
      dispatch(requestGroup(searchUrl));
      setPageUrl(searchUrl);
      setCurrentPage(1);
    } else {
      freshFetch();
      setPageUrl("");
      setCurrentPage(1);
    }
  };

  return {fetchAfterDelete, groups, handleSearch, paginationConfig, totalCount};
};
